import { render, staticRenderFns } from "./FleetManagementDetails.vue?vue&type=template&id=27d44c60&"
import script from "./FleetManagementDetails.vue?vue&type=script&lang=js&"
export * from "./FleetManagementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports